class OrderType {
  constructor(title) {
    this.title = title;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      orderTypeId: null,
      searchTitle: '',
      disabelConfirm: false,
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.confimType = 'add';
        for (let i = 0; i < this.allOrderTypes.length; i++) {
          if (this.allOrderTypes[i].id == 0) {
            return;
          }
        }
        this.allOrderTypes.push({ title: '', isEdit: true, id: 0 });
      } else if (type == 2) {
        this.confimType = 'edit';
        let temp = this.allOrderTypes;
        for (var i = 0; i < temp.length; i++) {
          if (temp[i].id == id) {
            temp[i].isEdit = true;
          }
        }
        this.allOrderTypes = [];
        this.allOrderTypes = temp;
        this.getOrderTypeFunction(id);
      }
    },
    cancelAddEditFunction: function (id) {
      this.orderType = new OrderType('');
      for (var i = 0; i < this.allOrderTypes.length; i++) {
        if (this.allOrderTypes[i].id == id) {
          if (id == 0) {
            this.allOrderTypes.splice(i, 1);
          }
          this.allOrderTypes[i].isEdit = false;
        }
      }
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addOrderTypeFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش نحوه تجویز';
        this.$refs.confirm.text = 'از ویرایش نحوه تجویز اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف نحوه تجویز';
        this.$refs.confirm.text = 'از حذف نحوه تجویز اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addOrderTypeFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editOrderTypeFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteOrderTypeFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.orderTypeId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
  },
};
